import React from 'react';
export default class ElegantResumeReference extends React.Component{

    getResumeBlock(data, index){
        let title = [];
        if (data.name){
            title.push(<span key="a" data-v-5a80631c="">{data.name}</span>)
        }

        if (data.title){
            title.push(<span key="b" data-v-5a80631c="">{data.title}</span>)
        }

        if (data.companyName){
            title.push(<span key="c" data-v-5a80631c="">{data.companyName}</span>)
        }

        let titleFinal = [];
        for(let i = 0; i < title.length; i++){
            titleFinal.push(title[i]);
            if(i + 1 < title.length){
                titleFinal.push(<span key={i} data-v-5a80631c="" className="comma">, </span>)
            }
        }

        return  <div data-v-5a80631c="" className="section-item" key={index}>
                    <div data-v-5a80631c="" className="section-title">
                        {titleFinal}
                    </div>
                    {data.email && <div data-v-5a80631c="" className="section-description">{data.email}</div>}
                    {data.phone && <div data-v-5a80631c="" className="section-description">{data.phone}</div>}
                    {data.address && <div data-v-5a80631c="" className="section-description">{data.address}</div>}
                </div>
    }

    render(){
        return  <div data-v-5a80631c="" className="section">
                    <div data-v-5a80631c="" className="section-headline">{this.props.title}</div>
                    {this.props.data.map((item, index) => {
                        return this.getResumeBlock(item, index);
                    })}
                </div>

    }
}